import {View} from 'backbone';
import template from 'common-views/badges.ejs';
import mobileTemplate from 'common-views/mobile-badges.ejs';
import constants from 'Constants.js';
import settingsService from 'MandatoryAndStateSettingsService.js';
import listService from 'ListService.js';
import mobileListService from 'mobile/MobileListService'
import eventBus from 'EventBus.js';

class BadgesView extends View {
    initialize(opts){
        this.listenTo(this.model, constants.EV_ROLE_AND_STAGE_SETTINGS_UPDATED, this.render);
        this.listenTo(eventBus, constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED, this.render.bind(this));
    }

    getMandatoryValue(){
        const
            options = {
                stageId: listService.getCurrentStage(),
                roleId: listService.getCurrentRole(),
                settings: this.model.get("mandatories"),
                defaultValue: "no",
                settingsField: "required"
            };

        return settingsService.getSetting(options);
    }

    getStateValue(){
        const
            options = {
                stageId: listService.getCurrentStage(),
                roleId: listService.getCurrentRole(),
                settings: this.model.get("state"),
                defaultValue: "default",
                settingsField: "value"
            };

        return settingsService.getSetting(options);
    }

    isMandatory(){
        return this.getMandatoryValue() === "yes";
    }

    isNormal(){
        return this.getStateValue() === "normal";
    }

    isHidden(){
        return this.getStateValue() === "hidden";
    }

    isReadOnly(){
        return this.getStateValue() === "readonly";
    }

    isDisabled(){
        return this.getStateValue() === "disabled";
    }

    getViewValues(){
        return {
            isMandatory: this.isMandatory(),
            isNormal: this.isNormal(),
            isHidden: this.isHidden(),
            isReadOnly: this.isReadOnly(),
            isDisabled: this.isDisabled()
        }
    }

    render() {
        this.$el.empty();

        if (listService.mainKind === constants.KIND_MOBILE) {
            const viewValues = this.getViewValues();
            let anyView = false;
            for (let view in viewValues) {
                if (viewValues[view]) {
                    anyView = true;
                }
            }

            if (this.model.get('factoryKey') !== "control_section") {
                if (anyView) {
                    this.$el.removeClass('no-mobile-badge-container').addClass('mobile-badge-container');
                }
                else {
                    this.$el.addClass('no-mobile-badge-container').removeClass('mobile-badge-container');
                }
            }


            this.$el.html(mobileTemplate(viewValues));
        }
        else {
            this.$el.html(template(this.getViewValues()));
        }
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.$el.empty();

        super.remove();
    }
}

export default BadgesView;
